import { render } from "./Subheading.vue?vue&type=template&id=40aa4a4e&scoped=true"
import script from "./Subheading.vue?vue&type=script&lang=js"
export * from "./Subheading.vue?vue&type=script&lang=js"

import "./Subheading.vue?vue&type=style&index=0&id=40aa4a4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40aa4a4e"]])

export default __exports__